import React from "react";
import {Typography} from "@mui/material";
import Grid from '@mui/material/Grid';
import {Stack, Box} from "@mui/system";

import SessionContentDetails from "./SessionContentDetails";
import SessionMemberDetails from "./SessionMemberDetails";
import LaunchMeetingButton from "./LaunchMeetingButton";
import SessionTimerDisplay from "./SessionTimerDisplay";
import {useSessionTimer} from "../../hooks/useSessionTimer";
import {useSessionStatus} from "../../hooks/useSessionStatus";

const styles = {
    box: {
        contentInfoMember: {
            alignItems: "flex-start",
            display: "flex",
            flex: 1,
            flexDirection: {xs: "column", lg: "row"},
            gap: "1rem",
            justifyContent: {xs: "space-between", lg: "space-evenly"}
        },
        buttonGroup: {
            alignItems: "flex-end",
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem",
            justifyContent: "space-between"
        }
    },
    typography: {
        sessionStatus: {
            color: '#666',
            display: "flex",
            marginRight: "2rem"
        }
    }
};

export default function SessionDetailsPanel({selectedEvent, serviceTypeDetails, currentTime, handleSessionLaunch, onPdfClick}) {

    const isZoomLinkCreated = Boolean(selectedEvent?.zoomMeetingUrl);

    const {hours, minutes, seconds} = useSessionTimer(selectedEvent, currentTime);
    const {sessionStatusInfo, isSessionStarted, isSessionEnded, canLaunchSession} = useSessionStatus(selectedEvent, currentTime);

    return (
      <>
        <Box alignItems="center" sx={styles.box.contentInfoMember}>
          <Box flex={1}>
            <SessionContentDetails contentInfos={selectedEvent.contents} onPdfClick={onPdfClick} />
          </Box>
          <Box flex={1}>
            <SessionMemberDetails selectedSessionEvent={selectedEvent} serviceType={serviceTypeDetails.type} />
          </Box>
        </Box>
        <Box sx={styles.box.buttonGroup}>
          <LaunchMeetingButton handleSessionLaunch={handleSessionLaunch} canLaunchSession={canLaunchSession} isZoomLinkCreated={isZoomLinkCreated} />
          <Stack>
            <Typography variant="subtitle2" style={styles.typography.sessionStatus} justifyContent="flex-end">
              {sessionStatusInfo}
            </Typography>
            <Grid>
              {!isSessionEnded && <SessionTimerDisplay {...{hours, minutes, seconds, isSessionStarted}} />}
            </Grid>
          </Stack>
        </Box>
      </>
    );
}
